// <!-- LEGAL REVIEW REQUIRED --> Template only. Placeholders are in LEGAL_TODO.md.
import React from 'react';
import { LegalPage } from '../../components/ui';
import { A11Y_RESPONSE, A11Y_REVIEWED, CONTACT_EMAIL, LEGAL_UPDATED } from '../../lib/legal';

const SECTIONS = [
  {
    title: '1. Our Commitment',
    body: 'Korsa is committed to making this website usable by everyone, including people with disabilities. Our goal is to meet the Web Content Accessibility Guidelines (WCAG) 2.1, Level AA.',
  },
  {
    title: '2. Last Review',
    body: `We last reviewed this website on ${A11Y_REVIEWED}, using automated testing and keyboard checks. We keep testing and fixing issues as the site changes.`,
  },
  {
    title: '3. Known Limitations',
    body: "Payment takes place on Stripe's hosted checkout page, which Stripe maintains. If anything there or on this website gets in your way, tell us and we will help you complete your order another way.",
  },
  {
    title: '4. Tell Us About a Problem',
    body: `Email ${CONTACT_EMAIL} with the page and the problem you ran into. We will respond within ${A11Y_RESPONSE}.`,
  },
];

const Accessibility = () => <LegalPage title="Accessibility Statement" updated={LEGAL_UPDATED} sections={SECTIONS} />;

export default Accessibility;
